<template>
  <div>
    <!-- <div style="width:500px; ">
    {{ buildingData }}
    </div> -->
    <!-- {{ selectedItem }} -->
    <div class="cd-info" v-if="buildingData.building_code">{{ buildingData.building_code }}</div>

    <div class="flex">
      <v-select dense outlined 
        id="company" 
        ref="companySelect" 
        label="경영체✽" 
        v-model="buildingData.company"
        :items="companyItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
        @change="updateSelectedCompany"
      />
      <v-select dense outlined
        id="farm" 
        ref="farm" 
        :label="buildingData.building_group.code === 'BF01' ? '농장명✽' : '사업장명✽'"
        v-model="buildingData.farm"
        :items="farmItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
        @focus="comboFarms()"
      />
    </div>

    <div class="mt-2 flex">
      <v-select dense outlined
        id="building_group" 
        ref="building_group" 
        class="selectmin"
        label="건물분류✽" 
        v-model="buildingData.building_group"
        :items="building_groupItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        return-object
      />
      <v-text-field dense outlined 
        class="textfield"
        id="building_name" 
        ref="building_name" 
        :label="buildingData.building_group.code === 'BF01' ? '축사명✽' : '건물명✽'"
        v-model="buildingData.building_name" 
      />
      <v-text-field dense outlined
        class="textfield"
        style="max-width:130px;"
        id="area" 
        ref="area" 
        :label="buildingData.building_group.code === 'BF01'? '축사면적✽' : '건물면적✽'" 
        suffix="m²" 
        v-model="buildingData.area" 
        onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
        maxlength="7"
      />
    </div>

    <div class="mt-2 flex" v-if="buildingData.building_group.code === 'BF01'">
      <v-select dense outlined 
        id="building_type" 
        ref="building_type" 
        class="selectmin"
        :items="building_typeItems"
        :menu-props="{ top: false, offsetY: true }"
        item-text="name"
        label="축사형태✽" 
        v-model="buildingData.building_type" 
        return-object
      />

      <div class="ml-3">
        <div style="height: 0px; letter-spacing: -1px; font-size:13px;"> 축사정보 상세입력 </div>

        <v-radio-group dense outlined row 
          id="detail_YN" 
          v-model="buildingData.detail_YN"
        >
          <v-radio
            ref="detail_y" 
            label="Y" value="Y" color="#005B96"
          ></v-radio>
          <v-radio
            label="N" value="N" color="#88191a"
          ></v-radio>
        </v-radio-group>
      </div>
    </div>

    <!-- 축사 상세정보 -->
    <div v-show="buildingData.detail_YN == 'Y'" class="detail_info">
      <div class="flex">
        <v-select dense outlined 
          id="air_type" 
          ref="air_type" 
          class="selectmid"
          label="환기유형" 
          v-model="buildingData.air_type"
          :items="air_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined  
          id="fan_type" 
          ref="fan_type" 
          class="selectmid"
          label="팬유형" 
          v-model="buildingData.fan_type"
          :items="fan_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined
          id="air_in" 
          ref="air_in" 
          class="selectmin"
          label="입기방식" 
          v-model="buildingData.air_in"
          :items="air_inItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined  
          id="air_out" 
          ref="air_out"
          class="selectmin" 
          label="배기방식" 
          v-model="buildingData.air_out"
          :items="air_outItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
      </div>

      <div class="flex mt-2">
        <v-select dense outlined
          id="roof_type" 
          ref="roof_type"
          class="selectmid"  
          label="지붕소재" 
          v-model="buildingData.roof_type"
          :items="roof_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />

        <v-select dense outlined 
          id="roof_color" 
          ref="roof_color" 
          class="selectmid"
          label="지붕색상" 
          v-model="buildingData.roof_color"
          :items="roof_colorItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        >
          <template slot="selection" slot-scope="data">
            <i :class="[data.item.color, 'mr-2', 'mdi', data.item.icon]"></i>
            <span class="color-info">{{ data.item.name }}</span>
          </template>
          <template v-slot:item="slotProps" >
            <i :class="[slotProps.item.color, 'mr-2', 'mdi', slotProps.item.icon]"></i>
            <span class="color-info">{{slotProps.item.name}}</span>
          </template>
        </v-select>

        <v-text-field dense outlined
          style="width:120px;"
          class="textfield"
          id="roof_width" 
          ref="roof_width" 
          label="지붕두께" 
          suffix="㎝" 
          v-model="buildingData.roof_width" 
          onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
          maxlength="7"
        />

        <v-text-field dense outlined
          style="width:120px;"
          class="textfield"
          id="wall_width" 
          ref="wall_width" 
          label="벽두께" 
          suffix="㎝" 
          v-model="buildingData.wall_width" 
          onKeyup="this.value=this.value.replace(/[^0-9.]/g,'');"
          maxlength="7"
        />
      </div>

      <div class="flex mt-2">
        <v-select dense outlined
          class="selectxmid"
          id="side_upper_type" 
          ref="side_upper_type" 
          label="측벽상단소재" 
          v-model="buildingData.side_upper_type"
          :items="side_upper_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />

        <v-select dense outlined
          class="selectxmid"
          id="side_upper_color" 
          ref="side_upper_color" 
          label="측벽상단색상" 
          v-model="buildingData.side_upper_color"
          :items="side_upper_colorItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        >
          <template slot="selection" slot-scope="data">
            <i :class="[data.item.color, 'mr-2', 'mdi', data.item.icon]"></i>
            <span class="color-info">{{ data.item.name }}</span>
          </template>
          <template v-slot:item="slotProps" >
            <i :class="[slotProps.item.color, 'mr-2', 'mdi', slotProps.item.icon]"></i>
            <span class="color-info">{{slotProps.item.name}}</span>
          </template>
        </v-select>

        <v-select dense outlined
          class="selectxmid"
          id="side_lower_type" 
          ref="side_lower_type" 
          label="측벽하단소재" 
          v-model="buildingData.side_lower_type"
          :items="side_lower_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
      </div>

      <div class="flex mt-2">
        <v-select dense outlined
          class="selectxmid"
          id="end_upper_type" 
          ref="end_upper_type" 
          label="끝벽상단소재" 
          v-model="buildingData.end_upper_type"
          :items="end_upper_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined
          class="selectxmid"
          id="end_upper_color" 
          ref="end_upper_color" 
          label="끝벽상단색상" 
          v-model="buildingData.end_upper_color"
          :items="end_upper_colorItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
          >
          <template slot="selection" slot-scope="data">
            <i :class="[data.item.color, 'mr-2', 'mdi', data.item.icon]"></i>
            <span class="color-info">{{ data.item.name }}</span>
          </template>
          <template v-slot:item="slotProps" >
            <i :class="[slotProps.item.color, 'mr-2', 'mdi', slotProps.item.icon]"></i>
            <span class="color-info">{{slotProps.item.name}}</span>
          </template>
        </v-select>
        <v-select dense outlined
          class="selectxmid"
          id="end_lower_type" 
          ref="end_lower_type" 
          label="끝벽하단소재" 
          v-model="buildingData.end_lower_type"
          :items="end_lower_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
      </div>

      <div class="flex mt-2">
        <v-select dense outlined
          class="selectxmid"
          id="inner_upper_type" 
          ref="inner_upper_type" 
          label="내벽상단소재" 
          v-model="buildingData.inner_upper_type"
          :items="inner_upper_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined
          class="selectxmid"
          id="inner_lower_type" 
          ref="inner_lower_type" 
          label="내벽하부소재" 
          v-model="buildingData.inner_lower_type"
          :items="inner_lower_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
        <v-select dense outlined
          class="selectxmid"
          id="ceiling_type" 
          ref="ceiling_type" 
          label="천장소재" 
          v-model="buildingData.ceiling_type"
          :items="ceiling_typeItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          clearable
        />
      </div>
    </div>

    <div class="hint-text">
      {{ buildingData.hint }}
    </div>

    <!-- <div class="flex mt-3">
      <v-text-field dense outlined
        class="textfield"
        id="ami_mac" 
        ref="ami_mac" 
        label="AMI 맥주소"  
        v-model="buildingData.ami_mac" 
        @keyup="sensorMacMask(buildingData.ami_mac)"
        @input="checkAmi()"
        maxlength="20"
        />

      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field dense outlined clearable
            class="textfield"
            id="deldate" 
            ref="deldate" 
            v-model="buildingData.deldate"
            label="사용중지일"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title locale="ko-KR"
          v-model="buildingData.deldate"
          @input="menu2 = false"
        ></v-date-picker>
      </v-menu>
    </div>

    <div class="mt-2">
      <v-textarea outlined dense rows="2"
        style="height:50px;"
        class="textarea-field"
        label="비고"
        id="history" 
        ref="history" 
        v-model="buildingData.history"
        value=""
        persistent-hint
        :hint="buildingData.hintRoom"
      ></v-textarea>
    </div> -->

    <div class="mt-5 flex vertical-center">
      <v-btn
          class="normal-btn mr-3"
          text
          id="save" 
          ref="save" 
          type="submit" 
          @click.prevent="save()"
        >
          저장
        </v-btn>
        <v-btn 
          class="new-btn"
          text
          id="newRegister" 
          ref="newRegister" 
          @click="resetBuildingData()">
          새로등록
        </v-btn>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";

export default{
  name: 'Building',

  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
    selectedCompany: {
      type: [String, Object], // 데이터 유형에 따라 수정
      default: null,
    },
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.buildingData = { ...this.buildingData, ...newValue }; 
        } else {
          this.resetBuildingData(); 
        }
      },
    },
    selectedCompany: {
      immediate: true,
      handler(newValue, oldValue) {
        this.resetBuildingData();
        if (newValue) {
          const company = this.companyItems.find(
            (item) => item.code === newValue
          );
          this.buildingData.company = company || null;
        }
      },
    },
  },
  data:() =>({
    buildingData:{
      company : {},
      farm : {},
      
      building_group: {},

      detail_YN:"",

      building_code : "",
      building_name : "",
      building_type :  {},
      area :  "",
      air_type :  "",
      air_in :  "",
      air_out :  "",
      fan_type :  "",
      
      roof_type : "",
      roof_color : "",
      roof_width : "",
      wall_width : "",
      
      side_upper_type : "",
      side_upper_color : "",
      side_lower_type : "",
      end_upper_type : "",
      end_upper_color : "",
      end_lower_type : "",
      inner_upper_type : "",
      inner_lower_type : "",
      ceiling_type : "",
      // deldate: "",
      // history: "",
      hint : "",

      // ami_mac :"",
    },
    companyItems: [],
    farmItems:[],

    building_groupItems : Common.comboBaseCode("BF"),
    building_typeItems : Common.comboBaseCode("BT"),

    air_typeItems : Common.comboBaseCode("AT"),
    air_inItems : Common.comboBaseCode("AI"),
    air_outItems : Common.comboBaseCode("AO"),
    fan_typeItems : Common.comboBaseCode("FT"),

    roof_typeItems : Common.comboBaseCode("RM"),
    roof_colorItems : Common.comboBaseCode("CR"),

    side_upper_typeItems : Common.comboBaseCode("BM"),
    side_upper_colorItems : Common.comboBaseCode("CR"),
    side_lower_typeItems : Common.comboBaseCode("BM"),

    end_upper_typeItems : Common.comboBaseCode("BM"),
    end_upper_colorItems : Common.comboBaseCode("CR"),
    end_lower_typeItems : Common.comboBaseCode("BM"),

    inner_upper_typeItems : Common.comboBaseCode("BM"),
    inner_lower_typeItems : Common.comboBaseCode("BM"),
    ceiling_typeItems : Common.comboBaseCode("BM"),

    menu2: false,
  }),
  created() {
    this.comboCompanies();
    this.comboFarms();
  },
  methods:{
    save(){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }

      if (this.buildingData.building_code) {
        // console.log('업데이트')
        Apis.updateBuildingFree({
          building_cd: this.buildingData.building_code,
          company_cd: this.buildingData.company?.code,
          farm_cd: this.buildingData.farm?.code,
          building_name: this.buildingData.building_name.trim(),
          building_type: this.buildingData.building_type.code || "",
          building_group: this.buildingData.building_group.code,
          area: Number(this.buildingData.area),
          air_type: this.buildingData.air_type && this.buildingData.air_type.code || "",
          air_in: this.buildingData.air_in && this.buildingData.air_in.code || "",
          air_out: this.buildingData.air_out && this.buildingData.air_out.code || "",
          fan_type: this.buildingData.fan_type && this.buildingData.fan_type.code || "",
          roof_type: this.buildingData.roof_type && this.buildingData.roof_type.code || "",
          roof_color: this.buildingData.roof_color && this.buildingData.roof_color.code || "",
          roof_width: Number(this.buildingData.roof_width),
          wall_width: Number(this.buildingData.wall_width),
          side_upper_type: this.buildingData.side_upper_type && this.buildingData.side_upper_type.code || "",
          side_upper_color: this.buildingData.side_upper_color && this.buildingData.side_upper_color.code || "",
          side_lower_type: this.buildingData.side_lower_type && this.buildingData.side_lower_type.code || "",
          end_upper_type: this.buildingData.end_upper_type && this.buildingData.end_upper_type.code || "",
          end_upper_color: this.buildingData.end_upper_color && this.buildingData.end_upper_color.code || "",
          end_lower_type: this.buildingData.end_lower_type && this.buildingData.end_lower_type.code || "",
          inner_upper_type: this.buildingData.inner_upper_type && this.buildingData.inner_upper_type.code || "",
          inner_lower_type: this.buildingData.inner_lower_type && this.buildingData.inner_lower_type.code || "",
          ceiling_type: this.buildingData.ceiling_type && this.buildingData.ceiling_type.code || "",
          // etc3 : '',
          // deldate: '',
          // history: '',

          },(res) => {  
            if (res.result) {
              // this.loadingSave = false;
              this.$store.commit("resMessage",res.message);

              this.$emit("refreshTreeData");
              this.resetBuildingData();
            } else {
              // this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              // this.loadingSave = false;
              console.log("updateBuildingFree API 호출 오류",err)
              alert(err);
          }
        )
      }else{
        // console.log('인서트')
        Apis.insertBuildingOne({
          company_cd: this.buildingData.company.code,
          farm_cd: this.buildingData.farm.code,
          building_name: this.buildingData.building_name.trim(),
          building_type: this.buildingData.building_type.code || "",
          building_group: this.buildingData.building_group.code,
          area: Number(this.buildingData.area),
          air_type: this.buildingData.air_type && this.buildingData.air_type.code || "",
          air_in: this.buildingData.air_in && this.buildingData.air_in.code || "",
          air_out: this.buildingData.air_out && this.buildingData.air_out.code || "",
          fan_type: this.buildingData.fan_type && this.buildingData.fan_type.code || "",
          roof_type: this.buildingData.roof_type && this.buildingData.roof_type.code || "",
          roof_color: this.buildingData.roof_color && this.buildingData.roof_color.code || "",
          roof_width: Number(this.buildingData.roof_width),
          wall_width: Number(this.buildingData.wall_width),
          side_upper_type: this.buildingData.side_upper_type && this.buildingData.side_upper_type.code || "",
          side_upper_color: this.buildingData.side_upper_color && this.buildingData.side_upper_color.code || "",
          side_lower_type: this.side_lower_type && this.side_lower_type.code || "",
          end_upper_type: this.buildingData.end_upper_type && this.buildingData.end_upper_type.code || "",
          end_upper_color: this.buildingData.end_upper_color && this.buildingData.end_upper_color.code || "",
          end_lower_type: this.buildingData.end_lower_type && this.buildingData.end_lower_type.code || "",
          inner_upper_type: this.buildingData.inner_upper_type && this.buildingData.inner_upper_type.code || "",
          inner_lower_type: this.buildingData.inner_lower_type && this.buildingData.inner_lower_type.code || "",
          ceiling_type: this.buildingData.ceiling_type && this.buildingData.ceiling_type.code || "",
          // etc3: '',
          // deldate: '',
          // history: '',

          },(res) => {  
            if (res.result) {
              this.loadingSave = false;
              this.$store.commit("resMessage",res.message);

              this.$emit("refreshTreeData");
              this.resetBuildingData();
            } else {
              // this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
              this.loadingSave = false;
              console.log("API 호출 오류",err)
              alert(err);
          }
        )
      }
    },
    checkData() {
      if (!this.buildingData.company.code) {
        this.$refs.companySelect.focus();
        return "상위 경영체를 선택입력하세요";
      }
      if (!this.buildingData.farm.code) {
        this.$refs.farm.focus();
        return "상위 사업장을 선택입력하세요";
      }
      if (!this.buildingData.building_name.trim()) {
        this.$refs.building_name.focus();
        return "건물명을 입력하세요";
      }
      if (!this.buildingData.building_group.code) {
        this.$refs.building_group.focus();
        return "건축분류를 선택입력하세요";
      }
      if (this.buildingData.building_group.code === 'BF01'){
        if (!this.buildingData.building_type.code) {
          this.$refs.building_type.focus();
          return "건물형태를 선택입력하세요";
        }
      }
      if (this.buildingData.building_group.code === 'BF01'){
        if (!this.buildingData.detail_YN){
          this.$refs.detail_y.$el.children[1].focus()
          return "상세정보 입력을 선택하세요";
        }
    }
      if (!this.buildingData.area) {
        this.$refs.area.focus();
        return "건물면적(㎡) 을 입력하세요";
      }
      return "";
    },
    resetBuildingData(){
      this.buildingData = {
        company : {},
        farm : {},
        
        building_group: {},

        detail_YN:"",

        building_code : "",
        building_name : "",
        building_type :  {},
        area :  "",
        air_type :  "",
        air_in :  "",
        air_out :  "",
        fan_type :  "",
        
        roof_type : "",
        roof_color : "",
        roof_width : "",
        wall_width : "",
        
        side_upper_type : "",
        side_upper_color : "",
        side_lower_type : "",
        end_upper_type : "",
        end_upper_color : "",
        end_lower_type : "",
        inner_upper_type : "",
        inner_lower_type : "",
        ceiling_type : "",
        // deldate: "",
        // history: "",
        hint : "",

        // ami_mac :"",
      }
    },
    infoDetail(value) {

    Apis.infoBuilding({
      building_cd: value.building_cd,
    },(res) => {
      if (res.result) {
        // console.log(res.data)
        
        this.buildingData = {
          ...this.buildingData,

          company: this.companyItems.find(
            (item) => item.code === this.selectedCompany
          ) || null,
          farm : {code: res.data.farm_cd.substr(0,6), name: res.data.farm_cd.substr(6)},
          building_group : {code: res.data.building_group.substr(0,4),name: res.data.building_group.substr(4)},
          building_name : res.data.building_name,
          area : res.data.area,

          building_code : res.data.building_cd,
          building_type : {code: res.data.building_type.substr(0,4),name: res.data.building_type.substr(4)},

          // 축사 상세정보
          air_type : { code: res.data.air_type.substr(0,4), name: res.data.air_type.substr(4)},
          air_in : { code: res.data.air_in.substr(0,4), name: res.data.air_in.substr(4)},
          air_out : { code: res.data.air_out.substr(0,4), name: res.data.air_out.substr(4)},
          fan_type : { code: res.data.fan_type.substr(0,4), name: res.data.fan_type.substr(4)}, 
          roof_type : { code: res.data.roof_type.substr(0,4), name: res.data.roof_type.substr(4)},
          roof_color : { code: res.data.roof_color.substr(0,4), name: res.data.roof_color.substr(4), color: res.data.etc1 },
          roof_width : res.data.roof_width,
          wall_width : res.data.wall_width,
          side_upper_type : { code: res.data.side_upper_type.substr(0,4), name: res.data.side_upper_type.substr(4)},
          side_upper_color : { code: res.data.side_upper_color.substr(0,4), name: res.data.side_upper_color.substr(4), color: res.data.etc1 },
          side_lower_type : { code: res.data.side_lower_type.substr(0,4), name: res.data.side_lower_type.substr(4)},
          end_upper_type : { code: res.data.end_upper_type.substr(0,4), name: res.data.end_upper_type.substr(4)},
          end_upper_color : { code: res.data.end_upper_color.substr(0,4), name: res.data.end_upper_color.substr(4), color: res.data.etc2 },
          end_lower_type : { code: res.data.end_lower_type.substr(0,4), name: res.data.end_lower_type.substr(4)},
          inner_upper_type : { code: res.data.inner_upper_type.substr(0,4), name: res.data.inner_upper_type.substr(4)} ,
          inner_lower_type : { code: res.data.inner_lower_type.substr(0,4), name: res.data.inner_lower_type.substr(4)},
          ceiling_type : { code: res.data.ceiling_type.substr(0,4), name: res.data.ceiling_type.substr(4)},
        
          // ami_mac : Common.getMacMask(res.data.etc3),
          // deldate : res.data.deldate,
          // history : res.data.history, 
          hint : res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정"
        };
        } else {
          this.loading = false;
          alert(res.message);
        }
      });
    },
    comboCompanies() {
      Apis.comboCompanies({
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.companyItems = [];
            for (let i in res.data) {
            this.companyItems.push({
              code: res.data[i].company_cd,
              name: res.data[i].company_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboCompanies API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    comboFarms() {
      Apis.comboFarms({
        company_cd: this.buildingData.company && this.buildingData.company.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          // console.log(res)
          if (res.result) {
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              biz : res.data[i].farm_biz
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    updateSelectedCompany(selectedCompany) {
      this.$emit("update:selectedCompany", selectedCompany?.code || null);
    },
    // sensorMacMask(val) {
    //   this.buildingData.ami_mac = Common.getMacMask(val)
    // },
    // checkAmi(){
    //   let mac = this.buildingData.ami_mac.replace(/:/gi, '')
    //   if (mac && mac.length !== 14) {
    //     this.$refs.ami_mac.focus();
    //     return "ami 맥주소를 확인해주세요";
    //   }
    //   return "";
    // },
  }
}
</script>

<style lang="scss" scoped>
@import '../info_style/info_style.scss';
.color-info{
  font-size:14px;
}
.detail_info{
  border:1px solid #eeeeee;
  padding:10px;
  border-radius: 10px;
}
</style>